import Vue from 'vue';
import { createActionHelpers } from 'vuex-loading';
import DatosService from './service';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

export const INIT = 'INIT';
export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_IMPORTES = 'UPDATE_IMPORTES';
export const UPDATE_GASTOS = 'UPDATE_GASTOS';
export const UPDATE_COMENTARIOS = 'UPDATE_COMENTARIOS';
export const ADD_DOCUMENTO = 'ADD_DOCUMENTO';
export const REMOVE_DOCUMENTO = 'REMOVE_DOCUMENTO';
export const UPDATE_TIPOS_CCAA = 'UPDATE_TIPOS_CCAA';
export const UPDATE_OPERATION = 'UPDATE_OPERATION';
export const UPDATE_TOTAL_EXPENSES = 'UPDATE_TOTAL_EXPENSES';
export const UPDATE_AJD_VALUE = 'UPDATE_AJD_VALUE';

export const UPSERT_LETRAS = 'UPSERT_LETRAS';
export const REMOVE_LETRAS = 'REMOVE_LETRAS';

export const initModuleAction = 'initModuleAction';
export const initDatosEconomicosAction = 'initDatosEconomicosAction';
export const clearDatosEconomicosModuleAction = 'clearDatosEconomicosModuleAction';
export const updateImportesDatosEconomicosAction = 'updateImportesDatosEconomicosAction';
export const updateGastosDatosEconomicosAction = 'updateGastosDatosEconomicosAction';
export const updateOperationAction = 'updateOperationAction';
export const initGastosEconomicosAction = 'initGastosEconomicosAction';
export const initLetrasAction = 'initLetrasAction';
export const updateTotalExpenses = 'updateTotalExpenses';
export const updateAjdValueAction = 'updateAjdValueAction';

export const upsertLetraAction = 'upsertLetraAction';
export const removeLetraAction = 'removeLetraAction';

export default {
  namespaced: true,
  state: {
    initialized: false,
    operation: null,
    letrasIds: [],
    letrasEntities: {},
    importes: {
      importe: '',
      tin: '',
      tae: '',
      responsabilidad: '',
      plazo: '',
      cuotas: false,
      renovable: false,
      interesRenovacion: '',
      tinReal: '',
      isLetra: false,
      otros: '',
      tca: '',
      cargasAnteriores: '',
      letra: '',
    },
    gastos: {
      notario: '',
      registro: '',
      timbres: '',
      gestoria: '',
      seguro: '',
      hacienda: '',
      tipoHacienda: '',
      varios: '',
      total: '',
    },
    tiposOperacionCuotas: [
      { value: 1, text: 'Sí' },
      { value: 0, text: 'No' },
    ],
    tiposRenovable: [
      { value: 1, text: 'Sí' },
      { value: 0, text: 'No' },
    ],
    tiposLetra: [
      { value: 1, text: 'Sí' },
      { value: 0, text: 'No' },
    ],
    totalExpenses: 0,
    comentarios: '',
    tiposComunidadAutonoma: [],
    timbres: [],
    ajdValue: 0,
  },
  mutations: {
    [INIT](state, payload) {
      Vue.set(state, 'initialized', payload);
    },
    [CLEAR_MODULE](state) {
      Vue.set(state, 'initialized', false);
      Vue.set(state, 'importes', {
        importe: '',
        tin: '',
        tae: '',
        responsabilidad: '',
        plazo: '',
        cuotas: false,
        renovable: false,
        interesRenovacion: '',
        tinReal: '',
        otros: '',
        tca: '',
        cargasAnteriores: '',
        letra: '',
      });
      Vue.set(state, 'gastos', {
        notario: '',
        registro: '',
        timbres: '',
        gestoria: '',
        seguro: '',
        hacienda: '',
        tipoHacienda: '',
        varios: '',
        total: '',
      });
      Vue.set(state, 'letrasIds', []);
      Vue.set(state, 'letrasEntities', {});
      Vue.set(state, 'tiposOperacionCuotas', {});
      Vue.set(state, 'tiposRenovable', {});
      Vue.set(state, 'tiposLetra', {});
      Vue.set(state, 'comentarios', '');
      Vue.set(state, 'tiposComunidadAutonoma', []);
      Vue.set(state, 'timbres', []);
      Vue.set(state, 'totalExpenses', 0);
      Vue.set(state, 'ajdValue', 0);
    },
    [UPSERT_LETRAS](state, payload) {
      const { entity } = payload;
      if ('id' in entity && entity.id !== '') {
        Vue.set(state.letrasEntities, entity.id, Vue._.cloneDeep(entity));
        const position = state.letrasIds.indexOf(entity.id);
        if (position < 0) {
          state.letrasIds.push(entity.id);
        } else {
          state.letrasIds = state.letrasIds.map(id => id);
        }
      }
    },
    [REMOVE_LETRAS](state, payload) {
      const { entity } = payload;
      if ('id' in entity && entity.id !== '') {
        const position = state.letrasIds.indexOf(entity.id);
        if (position > -1) {
          Vue.delete(state.letrasEntities, entity.id);
          state.letrasIds.splice(position, 1);
        }
      }
    },
    [UPDATE_IMPORTES](state, payload) {
      Vue.set(state, 'importes', payload);
    },
    [UPDATE_GASTOS](state, payload) {
      Vue.set(state, 'gastos', payload);
    },
    [UPDATE_COMENTARIOS](state, payload) {
      Vue.set(state, 'comentarios', payload);
    },
    [ADD_DOCUMENTO](state, payload) {
      Vue.set(state.documentos, payload.id, payload);
    },
    [REMOVE_DOCUMENTO](state, payload) {
      Vue.delete(state.documentos, payload.id);
    },
    [UPDATE_TIPOS_CCAA](state, payload) {
      state.tiposComunidadAutonoma = payload;
    },
    [UPDATE_OPERATION](state, payload) {
      Vue.set(state, 'operation', payload);
    },
    [UPDATE_TOTAL_EXPENSES](state, payload) {
      state.totalExpenses = payload;
    },
    [UPDATE_AJD_VALUE](state, payload) {
      state.ajdValue = payload;
    },
  },
  actions: {
    [initModuleAction]({ commit, dispatch, rootGetters }, op) {
      commit(CLEAR_MODULE);
      startLoading(dispatch, 'init datosEconomicos');
      dispatch(initDatosEconomicosAction, op)
        .then(() => dispatch(initGastosEconomicosAction, op))
        .then(() => dispatch(initLetrasAction, op))
        .then(() => endLoading(dispatch, 'init datosEconomicos'));
    },
    [initDatosEconomicosAction]({ commit }, opId) {
      // commit(CLEAR_MODULE);
      commit(UPDATE_OPERATION, opId);
      return DatosService.getVolumesByOperation(opId.id)
        .then((data) => {
          if (data.id && data.id !== 0) {
            commit(UPDATE_IMPORTES, data);
          }
        });
    },
    [initGastosEconomicosAction]({ commit }, opid) {
      // commit(CLEAR_MODULE);
      commit(UPDATE_OPERATION, opid);
      return DatosService.getGastosByOperation(opid.id)
        .then((data) => {
          if (data && data.id !== '') {
            commit(UPDATE_GASTOS, data);
          }
        });
    },
    [initLetrasAction]({ commit }, opid) {
      commit(UPDATE_OPERATION, opid);
      return DatosService.getLetrasByOperation(opid.id)
        .then((data) => {
          if (Array.isArray(data)) {
            data.forEach((instancia) => {
              commit(UPSERT_LETRAS, { entity: instancia });
            });
          }
        });
    },
    [clearDatosEconomicosModuleAction]({ commit }) {
      commit(CLEAR_MODULE);
    },
    [updateOperationAction]({ commit, dispatch, state, rootGetters }, payload) {
      let operation = {};
      const opid = rootGetters.getOpid;
      // const opid = ['operation_model/entitiesGetter'];

      if (payload.type === 'gastos') {
        operation = {
          id: opid,
          expenses: state.gastos.id,
        };
      } else if (payload.type === 'importes') {
        operation = {
          id: opid,
          volume: state.importes.id,
        };
      } else if (payload.type === 'letras') {
        operation = {
          id: opid,
          letras: state.letrasIds,
        };
      } else {
        operation = {
          id: opid,
          expenses: state.gastos.id,
          volume: state.importes.id,
        };
      }
      return dispatch('operation-tab/saveOperationAction', operation, { root: true });
    },
    [updateGastosDatosEconomicosAction]({ commit, rootGetters, dispatch }, payload) {
      startLoading(dispatch, 'update provisionFondos');
      let promise = null;
      const opid = rootGetters.getOpid;
      const gastosToSave = Vue._.merge({}, payload, { operation: opid });
      if (payload.id && payload.id !== '' && payload.id !== 'dummy') {
        promise = DatosService.updateGastosDatosEconomicos(gastosToSave);
      } else if (payload.id && payload.id !== '' && payload.id === 'dummy') {
        promise = DatosService.saveGastosDatosEconomicos(gastosToSave);
      } else {
        promise = Promise.reject('Incorrect data to save');
      }
      Promise.resolve(promise)
      .then((newData) => {
        commit(UPDATE_GASTOS, newData);
        dispatch('updateOperationAction', { opid, type: 'gastos' });
        endLoading(dispatch, 'update provisionFondos');
      }).catch((error) => {
        if (error && error.response) {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'update provisionFondos');
        }
      });
    },
    [updateImportesDatosEconomicosAction]({ commit, rootGetters, dispatch }, payload) {
      startLoading(dispatch, 'update calculoForm');
      let promise = null;
      const opid = rootGetters.getOpid;
      const importesToSave = Vue._.merge({}, payload, { operation: opid });
      if (payload.id && payload.id !== '' && payload.id !== 'dummy') {
        promise = DatosService.updateImporteDatosEconomicos(importesToSave);
      } else if (payload.id && payload.id !== '' && payload.id === 'dummy') {
        promise = DatosService.saveImporteDatosEconomicos(importesToSave);
      } else {
        promise = Promise.reject('Incorrect data to save');
      }
      return promise
      .then((newData) => {
        commit(UPDATE_IMPORTES, newData);
        dispatch('updateOperationAction', { opid, type: 'importes' });
        endLoading(dispatch, 'update calculoForm');
      })
        .catch((error) => {
          endLoading(dispatch, 'update calculoForm');
          dispatch('updateErrorOverlay', error, { root: true });
        });
    },
    [updateTotalExpenses]({ commit }, payload) {
      commit(UPDATE_TOTAL_EXPENSES, payload);
    },
    [updateAjdValueAction]({ commit }, payload) {
      commit(UPDATE_AJD_VALUE, payload);
    },
    [upsertLetraAction]({ commit, rootGetters, dispatch }, payload) {
      if ('id' in payload && payload.id !== '' && payload.id !== 'dummy') {
        return DatosService.updateLetra(payload)
          .then(res => commit(UPSERT_LETRAS, { entity: res }));
      }
      const opid = rootGetters.getOpid;
      return DatosService.createLetra(payload)
        .then((res) => {
          commit(UPSERT_LETRAS, { entity: res });
        })
        .then(() => dispatch('updateOperationAction', { opid, type: 'letras' }));
    },
    [removeLetraAction]({ commit }, payload) {
      return DatosService.removeLetra(payload)
        .then(() => commit(REMOVE_LETRAS, { entity: payload }));
    },
  },
  getters: {
    importes: state => state.importes,
    gastos: state => state.gastos,
    totalExpenses: state => state.totalExpenses,
    ajdValue: state => state.ajdValue,
    letras: state => state.letrasIds.map(id => state.letrasEntities[id]),
  },
};



// WEBPACK FOOTER //
// ./src/features/tab-datos-economicos/store.js